export const format = date => {
  const yyyy = date.getFullYear().toString();
  const mm = (date.getMonth() + 1).toString();
  const dd = date.getDate().toString();

  return `${yyyy}-${mm[1] ? mm : '0' + mm[0]}-${dd[1] ? dd : '0' + dd[0]}`;
};

export const subtractDays = (date, days) => {
  const clone = new Date(date);
  clone.setDate(clone.getDate() - days);
  return clone;
};

export const isDateSameDay = (a, b) => {
  return a.toDateString() === b.toDateString();
};

export const seconds = n => n * 1000;

export const days = n => n * 86400000;

const defaultFormatting = {
  hour: 'numeric',
  minute: '2-digit',
};

export const getDateFormatting = () => ({
  month: 'long',
  day: 'numeric',
  year: 'numeric',
});

export const getFormatting = (date, locale) => {
  const isToday = isDateSameDay(new Date(date), new Date());
  const isJapanese = locale === 'ja';
  const month = isJapanese ? 'long' : 'numeric';
  const year = isJapanese ? 'numeric' : '2-digit';
  return isToday
    ? defaultFormatting
    : {
        ...defaultFormatting,
        month,
        day: 'numeric',
        year,
      };
};

export const now =
  global.performance && global.performance.now
    ? () => global.performance.now()
    : () => Date.now();
